module.exports = __webpack_public_path__ + "static/025-7f514add10fc0710d3fd0b1842fc34b4.png";